module.exports = __webpack_public_path__ + "static/media/ThankYouGif1.36082ce3.gif";